import React, { useEffect, useState } from "react";

export default function FuturesContractUnitModal({ open, onClose, baseSymbol, quoteSymbol, initialId, onConfirm }) {
  const [draft, setDraft] = useState(initialId || "amount_base");

  useEffect(() => {
    if (open) setDraft(initialId === "value_quote" ? "value_quote" : "amount_base");
  }, [open, initialId]);

  if (!open) return null;

  const b = baseSymbol || "BTC";
  const q = quoteSymbol || "USDT";

  const rows = [
    {
      id: "amount_base",
      title: `Amount (${b})`,
      desc: `Order size is entered in ${b} (base asset).`,
    },
    {
      id: "value_quote",
      title: `Value (${q})`,
      desc: `Order size is entered in ${q} (notional / margin asset).`,
    },
  ];

  return (
    <div className="agcx-ft-modal-root" role="dialog" aria-modal="true" aria-labelledby="agcx-ft-contract-title">
      <button type="button" className="agcx-ft-modal-backdrop" aria-label="Close" onClick={onClose} />
      <div className="agcx-ft-modal-panel agcx-ft-modal-panel--contract">
        <div className="agcx-ft-modal-head">
          <h2 id="agcx-ft-contract-title" className="agcx-ft-modal-title">
            Contract Unit Settings
          </h2>
          <button type="button" className="agcx-ft-modal-close" aria-label="Close" onClick={onClose}>
            <i className="ri-close-line"></i>
          </button>
        </div>
        <div className="agcx-ft-modal-body">
          <div className="agcx-ft-contract-list">
            {rows.map((opt) => {
              const selected = draft === opt.id;
              return (
                <button
                  key={opt.id}
                  type="button"
                  className={`agcx-ft-contract-card${selected ? " is-selected" : ""}`}
                  onClick={() => setDraft(opt.id)}
                >
                  <div className="agcx-ft-contract-card__title">{opt.title}</div>
                  <div className="agcx-ft-contract-card__desc">{opt.desc}</div>
                </button>
              );
            })}
          </div>
        </div>
        <div className="agcx-ft-modal-foot">
          <button
            type="button"
            className="agcx-ft-btn agcx-ft-btn--primary"
            onClick={() => {
              onConfirm?.(draft);
              onClose?.();
            }}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
